export const perPageCount = 10
